import { STRING, GEOMETRY } from '../attribute_type';

class FeatureProperty {

	constructor(namespace, type, name, order) {
		this.namespace = namespace;
		this.type = type;
		this.name = name;
		this.property_type = STRING;
		this.geometry_type = null;
		this.order = order;
		this.hits = 0;
	}
	
	getNamespace() { 
		return this.namespace;
	}
	
	getType() { 
		return this.type;
	}

    getName() {
     	return this.name;
    }	
    
    getPropertyType() {
        return this.property_type || -1;
    }
        
    isGeometry() {
    	return this.property_type === GEOMETRY;
    }
    
    getGeometryType() {
    	return this.geometry_type;
    }
    
    getOrder() {
    	return this.order;
    }
    
    isNotNull() {
		return this.hits === this.type.hits;
	}
    
    updateGeometryType(geometryType) { 
		this.property_type = GEOMETRY;
    	this.geometry_type = geometryType;
    }
    
    addHit() {
		this.hits++;
		return this;
	}
}

class FeatureType {

	constructor(namespace, localName) {
		this.namespace = namespace;
		this.localName = localName;	
		this.properties = {};
		this.order = 0;
		this.hits = 0;
	}

	getNamespace() { 
		return this.namespace;
	}

    getLocalName() {
    	return this.localName;
    }
    
    add(namespace, property) {
		if( this.properties[property] === undefined ) {
			this.properties[property] = new FeatureProperty(namespace, this, property, this.order++);
		}
		
		return this.properties[property].addHit();
    }
    
    getProperties() {
		return Object.values(this.properties);
	}
    
    addHit() {
		this.hits++;
		return this;
	}
}

class FeatureNamespace {	
	
	constructor(namespaceURI, prefix) {
		this.namespaceURI = namespaceURI;
		this.prefix = prefix;	
		this.types = {}
	}
	
	getType(localName) {
		if( this.types[localName] === undefined ) {
			this.types[localName] = new FeatureType(this, localName);
		}
		
		return this.types[localName].addHit();
	}
	
	getTypes() {
		return Object.values(this.types);
	}
	
	getPrefix() {
		return this.prefix;		
	}
	
	getNamespaceURI() {
		return this.namespaceURI;
	}
	
}

const isSimpleType = node => {
	const nodes = node.childNodes;
	for( let i = 0; node instanceof Element && i < nodes.length; i++) {
		const child = nodes.item(i);
		if( !(child instanceof Text) ) {
			return false;
		}
	}
	
	return node instanceof Element;
}

class GMLFormat {
	
	constructor(gml_version, namespaceURI, memberName) {
		this.gml_version = gml_version;
		this.namespaceURI = namespaceURI;
		this.memberName = memberName;
		this.namespaces = {};
		this.geometryTypes = {};
	}
	
	addGeometryType( elementName, geometryType ) {
		this.geometryTypes[elementName] = geometryType;
	} 
	
	getGMLVersion() {
		return this.gml_version;
	}
	
	getNamespaces() {
		return Object.values(this.namespaces);
	}
	
	getNamespace(namespaceURI, prefix) {
		if( this.namespaces[namespaceURI] === undefined ) {
			this.namespaces[namespaceURI] = new FeatureNamespace(namespaceURI, prefix);
		}
		
		return this.namespaces[namespaceURI];
	}
	
	is_valid(element) {
		return element.namespaceURI == this.namespaceURI && element.localName === 'FeatureCollection';
	} 
	
	isFeatureMember(node) {
		return node.namespaceURI === this.namespaceURI && node.localName === this.memberName;
	}
	
	readFeatureMember(element) {				
		const namespace = this.getNamespace(element.namespaceURI, element.prefix);
		const type = namespace.getType(element.localName);
				
		const nodes = element.childNodes;

		for( let i = 0; i < nodes.length; i++) {
			const child = nodes.item(i);
			
			if( isSimpleType(child) ) {
				const elementNamespace = this.getNamespace(child.namespaceURI, child.prefix);				
				type.add(elementNamespace, child.localName);	
			} else if( child instanceof Element ) {
				const geometryType = this.getGeometryPropertyType( child );
				
				if( geometryType ) {
					const elementNamespace = this.getNamespace(child.namespaceURI, child.prefix);				
					type.add(elementNamespace, child.localName).updateGeometryType(geometryType);	
				} else {
					console.log( child, nodes, i );
				}
			} else if( !(child instanceof Text) ) {
				console.log( child, nodes, i );
			}
		}
	}
	
	getGeometryPropertyType(element) {
		const nodes = element.childNodes;
		let geometryType = undefined;
		for( let i = 0; i < nodes.length && geometryType === undefined; i++) {
			const child = nodes.item(i);
			if( child instanceof Element && child.namespaceURI === this.namespaceURI) {
				geometryType = this.getGeometryType(child)
			}
		}
		
		return geometryType;
	}
	
	getGeometryType(element) {
		const type =  this.geometryTypes[element.localName];
		if( !type ) {
			console.warn("Unknown GML geometry type: ", element.localName);
		}
		
		return type;
	}
	
	accept(element, featureMember) { 
		if( element instanceof Element ) {			
			const nodes = element.childNodes;

			for( let i = 0; i < nodes.length; i++) {
				const child = nodes.item(i);
				
				if( featureMember && child instanceof Element ) {
					this.readFeatureMember(child);
				} else if( !featureMember ) {
					this.accept(child, this.isFeatureMember(child));
				}
			}
		}
	}
	
	read(element) {
		this.accept(element);
		
		return this;
	}
	
}

export default GMLFormat;